/* LEVEL interactive cannabinoid board — periodic-table-style reference.
   Reusable blog element; NOT a wheel (distinct from the terpene module).
   Drop <div id="level-cannabinoid-board"></div> into any article body; this
   script (loaded on article pages via theme.liquid) renders the module into it.
   Paired with cannabinoid-board.css. Self-guards.
   Capitalization house style: base forms all-caps (CBD, CBG, CBN, CBC);
   acid forms lowercase 'a' (CBDa, CBGa, THCa); varins lowercase 'v' (CBDv, THCv). */
(function(){
  function init(){
    var root=document.getElementById('level-cannabinoid-board');
    if(!root || root.dataset.cbInit==='1') return;
    root.dataset.cbInit='1';
    root.classList.add('cbrd');

    var CAT={
      Major:{label:"MAJOR",   base:"#2ed9c3", ink:"#159b8a", tint:"#e8faf7"},
      Minor:{label:"EMERGENT",base:"#19bde8", ink:"#1391b4", tint:"#e6f7fc"},
      Varin:{label:"VARIN",   base:"#8a84d6", ink:"#635cc0", tint:"#efeefb"},
      Acid: {label:"RAW ACID",base:"#ffb548", ink:"#c9871c", tint:"#fff4e2"}
    };

    // Ordered so categories cluster on the board (like a periodic table).
    var CANNA=[
      {sym:"CBD", full:"Cannabidiol",              cat:"Major", type:"Major cannabinoid", tag:"The everyday foundation", assoc:["Balance","Everyday calm","Full-spectrum base"], note:"The most abundant non-intoxicating cannabinoid in hemp and the backbone of most wellness formulas. Widely studied and associated with an everyday sense of balance."},
      {sym:"CBG", full:"Cannabigerol",             cat:"Major", type:"Major cannabinoid", tag:"The mother cannabinoid", assoc:["Focus","Clarity"], note:"Often called the 'mother cannabinoid': the plant's CBGa precursor converts into other cannabinoids as it grows. Non-intoxicating, and explored for a clear-headed, focused feel."},
      {sym:"CBN", full:"Cannabinol",               cat:"Minor", type:"Emergent cannabinoid", tag:"The wind-down one", assoc:["Sleep","Rest"], note:"Forms slowly as cannabinoids age and oxidize. Non-intoxicating, and most associated with winding down and the evening routine."},
      {sym:"CBC", full:"Cannabichromene",          cat:"Minor", type:"Emergent cannabinoid", tag:"The team player", assoc:["Entourage","Everyday support"], note:"A lesser-known non-intoxicating cannabinoid usually studied for how it works together with CBD and others — a key part of the 'entourage effect.'"},
      {sym:"CBDv",full:"Cannabidivarin",           cat:"Varin", type:"Varin cannabinoid", tag:"The CBD cousin", assoc:["Emerging research"], note:"A 'varin' cousin of CBD with a slightly shorter molecular tail. Non-intoxicating, and an active, emerging area of cannabinoid research."},
      {sym:"THCv",full:"Tetrahydrocannabivarin",   cat:"Varin", type:"Varin cannabinoid", tag:"The distinct varin", assoc:["Emerging research"], note:"A varin cannabinoid with a distinct profile that appears in only small amounts in most hemp. Studied as an emergent cannabinoid of growing interest."},
      {sym:"CBDa",full:"Cannabidiolic acid",       cat:"Acid",  type:"Raw acid form", tag:"CBD, before the heat", assoc:["Raw plant","Recovery"], note:"The raw, acidic form of CBD present in the living hemp plant before heat converts it to CBD. Non-intoxicating, and increasingly studied in its own right."},
      {sym:"CBGa",full:"Cannabigerolic acid",      cat:"Acid",  type:"Precursor acid", tag:"The true starting point", assoc:["Precursor","Plant chemistry"], note:"The acidic precursor the plant uses to build other cannabinoid acids — the origin point of the whole cannabinoid family tree."},
      {sym:"THCa",full:"Tetrahydrocannabinolic acid", cat:"Acid", type:"Raw acid form", tag:"Raw & non-intoxicating", assoc:["Raw plant"], note:"The raw, acidic form found in the living plant. Non-intoxicating in its natural state — its character only changes when heated."}
    ];

    var CANNA_URL="https://levelexperience.shop/pages/cannabinoids-targeted-benefits";
    var N=CANNA.length;

    var legend=Object.keys(CAT).map(function(k){
      return '<span class="cbrd__legitem"><span class="cbrd__legdot" style="background:'+CAT[k].base+'"></span>'+CAT[k].label+'</span>';
    }).join('');

    var tiles=CANNA.map(function(c,i){
      var cc=CAT[c.cat];
      return '<button class="cbrd__tile" type="button" data-i="'+i+'" '+
             'style="--cb-tint:'+cc.tint+';--cb-base:'+cc.base+';--cb-tinkink:'+cc.ink+'" '+
             'aria-label="'+c.sym+', '+c.full+', '+c.type+'">'+
             '<span class="cbrd__cat">'+cc.label+'</span>'+
             '<span class="cbrd__sym">'+c.sym+'</span>'+
             '<span class="cbrd__full">'+c.full+'</span>'+
             '</button>';
    }).join('');

    root.innerHTML =
      '<p class="cbrd__eyebrow">Interactive &middot; Cannabinoid Board</p>'+
      '<h2 class="cbrd__title">Meet the Cannabinoids</h2>'+
      '<p class="cbrd__lede">Hemp is far more than a single molecule. These are the cannabinoids behind it &mdash; grouped by how the plant builds them. Tap any tile to see what it is and where it fits.</p>'+
      '<div class="cbrd__legend">'+legend+'</div>'+
      '<div class="cbrd__grid" role="list">'+tiles+'</div>'+
      '<div class="cbrd__panel" aria-live="polite">'+
        '<div class="cbrd__ptop"><span class="cbrd__dot" data-dot></span><div>'+
          '<h3 class="cbrd__pname" data-pname>Select a cannabinoid</h3>'+
          '<p class="cbrd__family" data-pfam>9 cannabinoids &middot; 4 groups</p>'+
        '</div></div>'+
        '<p class="cbrd__tag" data-ptag><span class="cbrd__hint">Tap a tile above to reveal what each cannabinoid is, what it&rsquo;s associated with, and where it sits in the family.</span></p>'+
        '<div data-pdetail hidden>'+
          '<p class="cbrd__lab">Commonly associated with</p>'+
          '<div class="cbrd__chips" data-pchips></div>'+
          '<p class="cbrd__lab" style="margin-top:14px">Good to know</p>'+
          '<p class="cbrd__note" data-pnote></p>'+
        '</div>'+
      '</div>'+
      '<div class="cbrd__foot">'+
        '<div class="cbrd__cta">'+
          '<p class="cbrd__ctatxt">Every cannabinoid pulls in a different direction. <span>See how LEVEL pairs them with targeted, effect-based benefits.</span></p>'+
          '<a class="cbrd__btn" href="'+CANNA_URL+'">Explore Cannabinoids by Benefit '+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'+
          '</a>'+
        '</div>'+
        '<p class="cbrd__disc">For education only. Descriptions and associations are illustrative and are not health, medical, or product claims. Cannabinoid content varies by product; see individual product pages and COAs for specifics.</p>'+
      '</div>';

    var tileEls=Array.prototype.slice.call(root.querySelectorAll('.cbrd__tile')),
        pdot=root.querySelector('[data-dot]'),
        pname=root.querySelector('[data-pname]'),
        pfam=root.querySelector('[data-pfam]'),
        ptag=root.querySelector('[data-ptag]'),
        pdetail=root.querySelector('[data-pdetail]'),
        pchips=root.querySelector('[data-pchips]'),
        pnote=root.querySelector('[data-pnote]');

    var locked=-1;
    function clear(){
      tileEls.forEach(function(t){t.classList.remove('on');});
      pdot.style.background="var(--cb-accent)";
      pdot.textContent="";
      pname.textContent="Select a cannabinoid";
      pfam.textContent=N+" cannabinoids · 4 groups";
      ptag.innerHTML='<span class="cbrd__hint">Tap a tile above to reveal what each cannabinoid is, what it’s associated with, and where it sits in the family.</span>';
      pdetail.hidden=true;
    }
    function select(i,lock){
      if(lock){ if(locked===i){ locked=-1; clear(); return; } locked=i; }
      var c=CANNA[i], cc=CAT[c.cat];
      tileEls.forEach(function(t,k){t.classList.toggle('on',k===i);});
      pdot.style.background=cc.base;
      pdot.textContent=c.sym;
      pname.textContent=c.sym;
      pfam.textContent=c.full+" · "+c.type;
      ptag.textContent=c.tag;
      pchips.innerHTML="";
      c.assoc.forEach(function(x){var s=document.createElement('span');s.className='cbrd__chip';s.textContent=x;pchips.appendChild(s);});
      pnote.textContent=c.note;
      pdetail.hidden=false;
    }

    tileEls.forEach(function(t,i){
      t.addEventListener('mouseenter',function(){ if(locked<0) select(i,false); });
      t.addEventListener('click',function(){ select(i,true); });
    });
    root.querySelector('.cbrd__grid').addEventListener('mouseleave',function(){
      if(locked>-1) select(locked,false); else clear();
    });
  }

  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded",init); }
  else { init(); }
})();
